// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formik-double-pole-switch {
  justify-content: space-between;
  align-items: center;
  width: 100%;
  display: flex;
}

.formik-double-pole-switch__label {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  margin: 0;
  font-size: 13px;
  font-weight: normal;
}

.formik-double-pole-switch__label--disabled {
  cursor: not-allowed;
}

.formik-double-pole-switch__area {
  cursor: pointer;
  background: #323232;
  border-radius: 9px;
  width: 42px;
  height: 18px;
  margin: 0 8px;
  transition: all .2s;
  display: inline-block;
  position: relative;
}

.formik-double-pole-switch__area--with-value {
  background: #48a77c;
}

.formik-double-pole-switch__area--disabled {
  cursor: not-allowed;
  opacity: .5;
}

.formik-double-pole-switch__control {
  background: #fff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  transition: all .2s;
  display: inline-block;
  position: absolute;
  top: 1px;
  left: calc(50% - 8px);
}

.formik-double-pole-switch__control--left {
  left: 1px;
}

.formik-double-pole-switch__control--right {
  left: 25px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/FormikDoublePoleSwitchField/styles.css","webpack://./services/frontend/app/components/FormikDoublePoleSwitchField/styles.css"],"names":[],"mappings":"AADA;ECEE,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".formik-double-pole-switch {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.formik-double-pole-switch__label {\n  font-weight: normal;\n  margin: 0;\n  cursor: pointer;\n  -webkit-user-select: none;\n          user-select: none;\n  font-size: 13px;\n}\n\n.formik-double-pole-switch__label--disabled {\n  cursor: not-allowed;\n}\n\n.formik-double-pole-switch__area {\n  background: #323232;\n  border-radius: 9px;\n  cursor: pointer;\n  display: inline-block;\n  height: 18px;\n  position: relative;\n  width: 42px;\n  transition: all 200ms ease;\n  margin: 0 8px;\n}\n\n.formik-double-pole-switch__area--with-value {\n  background: #48a77c;\n}\n\n.formik-double-pole-switch__area--disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.formik-double-pole-switch__control {\n  background: #fff;\n  border-radius: 50%;\n  display: inline-block;\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  left: calc(50% - 8px);\n  top: 1px;\n  transition: all 200ms ease;\n}\n\n.formik-double-pole-switch__control--left {\n  left: 1px;\n}\n\n.formik-double-pole-switch__control--right {\n  left: 25px;\n}\n",".formik-double-pole-switch {\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  display: flex;\n}\n\n.formik-double-pole-switch__label {\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  margin: 0;\n  font-size: 13px;\n  font-weight: normal;\n}\n\n.formik-double-pole-switch__label--disabled {\n  cursor: not-allowed;\n}\n\n.formik-double-pole-switch__area {\n  cursor: pointer;\n  background: #323232;\n  border-radius: 9px;\n  width: 42px;\n  height: 18px;\n  margin: 0 8px;\n  transition: all .2s;\n  display: inline-block;\n  position: relative;\n}\n\n.formik-double-pole-switch__area--with-value {\n  background: #48a77c;\n}\n\n.formik-double-pole-switch__area--disabled {\n  cursor: not-allowed;\n  opacity: .5;\n}\n\n.formik-double-pole-switch__control {\n  background: #fff;\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  transition: all .2s;\n  display: inline-block;\n  position: absolute;\n  top: 1px;\n  left: calc(50% - 8px);\n}\n\n.formik-double-pole-switch__control--left {\n  left: 1px;\n}\n\n.formik-double-pole-switch__control--right {\n  left: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
